import { IOffer } from '../../../types/offer';
import { numberToPrettyString } from '@cian/utils';

export function getRoomArea(offer: IOffer): string | undefined {
  if (offer.roomArea) {
    return numberToPrettyString(Number(offer.roomArea));
  }

  return undefined;
}
